/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChargeIVRTokenPost } from '../models/ChargeIVRTokenPost';
import type { ChargeToken } from '../models/ChargeToken';
import type { ThirdPartyACHTokenCreate } from '../models/ThirdPartyACHTokenCreate';
import type { ThirdPartyTokenCreate } from '../models/ThirdPartyTokenCreate';
import type { ThirdPartyTokenUpdate } from '../models/ThirdPartyTokenUpdate';
import type { TokenDetails } from '../models/TokenDetails';
import type { TokenIdModel } from '../models/TokenIdModel';
import type { TokenUrlForm } from '../models/TokenUrlForm';
import type { TransactionDetails } from '../models/TransactionDetails';
import type { UpdateToken } from '../models/UpdateToken';
import { request as __request } from '../core/request';

export class TokensVService {

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static async tokensVGetCcUrl(
        billingAccountId: string,
        requestBody?: TokenUrlForm,
    ): Promise<string> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/cc-url`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static async tokensVGetAchUrl(
        billingAccountId: string,
        requestBody?: TokenUrlForm,
    ): Promise<string> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/ach-url`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param tokenId
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async tokensVCharge(
        billingAccountId: string,
        tokenId: string,
        requestBody?: ChargeToken,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/${tokenId}/charge`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param isSaved
     * @param requestBody
     * @returns TokenDetails Created
     * @throws ApiError
     */
    public static async tokensVCreateCc(
        billingAccountId: string,
        isSaved: boolean = false,
        requestBody?: TokenIdModel,
    ): Promise<TokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/cc/create`,
            query: {
                'isSaved': isSaved,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param isSaved
     * @param requestBody
     * @returns TokenDetails Created
     * @throws ApiError
     */
    public static async tokensVCreateAch(
        billingAccountId: string,
        isSaved: boolean = false,
        requestBody?: TokenIdModel,
    ): Promise<TokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/ach/create`,
            query: {
                'isSaved': isSaved,
            },
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns TokenDetails Created
     * @throws ApiError
     */
    public static async tokensVCreateThirdPartyAch(
        billingAccountId: string,
        requestBody?: ThirdPartyACHTokenCreate,
    ): Promise<TokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/ach/third-party`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns TokenDetails Created
     * @throws ApiError
     */
    public static async tokensVCreateThirdParty(
        billingAccountId: string,
        requestBody?: ThirdPartyTokenCreate,
    ): Promise<TokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/third-party`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param tokenId
     * @param requestBody
     * @returns TokenDetails OK
     * @throws ApiError
     */
    public static async tokensVUpdateThirdParty(
        billingAccountId: string,
        tokenId: string,
        requestBody?: ThirdPartyTokenUpdate,
    ): Promise<TokenDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/third-party/${tokenId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async tokensVChargeIvr(
        billingAccountId: string,
        requestBody?: ChargeIVRTokenPost,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/ivr/charge`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param tokenId
     * @param requestBody
     * @returns TokenDetails OK
     * @throws ApiError
     */
    public static async tokensVUpdateToken(
        billingAccountId: string,
        tokenId: string,
        requestBody?: UpdateToken,
    ): Promise<TokenDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/${tokenId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param billingAccountId
     * @param tokenId
     * @returns any No Content
     * @throws ApiError
     */
    public static async tokensVDeleteToken(
        billingAccountId: string,
        tokenId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v3/billing-accounts/${billingAccountId}/tokens/${tokenId}`,
        });
        return result.body;
    }

}